<div class="ce-container">
  <div class="card">
    <div class="customer-experience mb-5">
      <img class="customer-experience-img" src="/assets/images/netcore_ce.svg" alt="Customer Experience Netcore Logo">
    </div>
    <div class="row px-1">
      <div class="col-md-6">
        <iframe height="330" src="https://www.youtube.com/embed/02Lchv_3GWs">
        </iframe>
      </div>
      <div class="col-md-6 content-block">
        <div class="cee-text">Sorry, you don’t have access to CEE.</div>
        <p class="text-desc">Netcore’s Customer Engagement is an intelligent platform that helps you increase
          conversion
          and retention.
        </p>
        <p class="text-desc">Simply request the access using the button below or write to us at
          <a class="helpdesk-link" href="mailto:helpdesk@netcorecloud.com">helpdesk@netcorecloud.com</a> to get the
          platform enabled.</p>
        <a href="mailto: helpdesk@netcorecloud.com"><button class="px-primary-btn-xs">Request access</button></a>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-center">
      <div class="footer-link cee-resource mx-4 d-flex align-items-center">
        <img class="pr-3" src="/assets/images/cee_resource.svg" alt="">
        <a target="_blank" href="https://cedocs.netcorecloud.com/"><span>CEE Resources</span></a>
      </div>
      <div class="footer-link ce-platform mx-4 d-flex align-items-center">
        <img class="pr-3" src="/assets/images/ce-platform.svg" alt="">
        <a target="_blank" href="https://netcorecloud.com/customer-engagement/"><span>What is Customer Engagement
            platform?</span></a>
      </div>
    </div>
  </div>
</div>
